import React, { useContext, useEffect } from 'react';
import { Watermark } from '@mummssoftware/common-ui';
import { Snackbar } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { Context } from '../../context';
import { HospiceItemSmallTable } from './HospiceItemSmallTable';
import { HospiceItemExpandedTable } from './HospiceItemExpandedTable';
import { Container } from '../../components/layout/WrapperDiv';
import { vertical } from './constants';

export declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber: string;
}>;

type HospiceItemSetProps = {
  currentUser: mumms.User;
  online: boolean;
  patient?: mumms.patient;
  hospiceInfo: mumms.HIS;
  appTitle?: string;
  view?: string | null;
  smallWidget?: boolean;
} & typeof RouteProps;

export const HospiceItemSetComponent = ({
  smallWidget,
}: HospiceItemSetProps) => {
  const {
    watermark,
    onWidgetReady,
    errorInfo,
    clearError,
    startLoadingTime,
  } = useContext(Context);

  useEffect(() => {
    const loadingDuration = (Date.now() - startLoadingTime) / 1000;
    // callback to alert dashboard the view is ready
    onWidgetReady && onWidgetReady('HospiceItemSet' as mumms.ComponentName);
    console.log('## HOSPICE ITEM SET WIDGET END ##', loadingDuration, 's');

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Alert = (props: AlertProps) => (
    <MuiAlert elevation={6} variant="filled" {...props} />
  );
  return (
    <Container id="hospice-item-set-container">
      {watermark && watermark.show ? (
        <Watermark readOnly={watermark.readOnly} smallWidget={smallWidget} />
      ) : null}
      <Snackbar
        open={!!errorInfo}
        autoHideDuration={3000}
        onClose={() => clearError()}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert onClose={() => clearError()} severity="error">
          {errorInfo}
        </Alert>
      </Snackbar>
      {smallWidget ? (
        <HospiceItemSmallTable mode={vertical} />
      ) : (
        <HospiceItemExpandedTable />
      )}
    </Container>
  );
};

export default HospiceItemSetComponent;
